import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export const sidenav = css.nav`  
  nav {
    overflow: hidden;
    width: 325px;
    left: -325px;
    transition: 0.3s ease-in-out;
    position: fixed;
    top: 0;
    height: 100%;
    border-right: 2px solid #EEEEEE;
    z-index: 99999;

  }
  
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .fixed {
    width: 325px;
    background: #ffffff;
    padding-top: 0px;
    padding-bottom: 7px;
    box-sizing: border-box;
    position: fixed;
    z-index: 99999;
  }

  nav.open {
    left: 0;
    transition: 0.3s ease-in-out;
  }
  
  .overlay {
    position: fixed;
    visibility: hidden;
    width: 100%;
    height: 100%;
    background: ${theme.colors.codGray};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }  

  .overlay.show {
    left: 325px;
    visibility: visible;
    opacity: 0.7;
    z-index: 99998;
  }
  
  .container-close-button {
    height: 72px;
    margin-left: -10px;
    flex-basis: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .close-button {
    padding: 10px;
    margin: 0 24px;
    width: fit-content;
    height: 20px;
    position: relative;
    cursor: pointer;
  }

  .close-button:before, .close-button:after {
    position: absolute;
    content: '';
    height: 20px;
    width: 3px;
    background-color: ${theme.colors.mineShaft};
    left: 10px;
  }
  
  .close-button:before {
    transform: rotate(45deg);
  }

  .close-button:after {
    transform: rotate(-45deg);
  }
  
  .nav-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    padding-bottom: 0;
    padding-top: 130px;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
  }

  a {
    text-decoration: none;
  }

  li {
    padding: 16px 24px;
    list-style-type: none;
  }

  ul li a {
    font-style: normal;
    width: max-content;
    font-weight: normal;
    font-size: 16px;
    line-height: 130%;
    color: ${theme.colors.codGray};
    display: block;
  }

  ul li a:hover {
    color: ${theme.colors.lightBlue};
    transition: color 0.1s ease-in;
  }

  ul {
    flex-shrink: 0;
    overflow: hidden;
    max-height: 5000px;
    margin: 0;
    padding: 0;
    transition: max-height 1s ease-in-out;
  }
  
  ul.collapsed {
    max-height: 0;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  }
  
  .live-block {
    padding: 4px 0 5px 10px;
  }

  .heading-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    cursor: pointer;
    border-top: 1px solid ${theme.colors.lightGray3};
    transition: 0.4s;
  }

  .heading {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #0D0D0D;
  }
  
  .live-button {
    font-family: Graphik;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    text-align: justify;
    color: ${theme.colors.navy};
  }
 
  .live-button:hover {
    color: ${theme.colors.lightBlue};
  }
  
  .blink {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: ${theme.colors.alertRed};
    border-radius: 50%;
    margin-right: 4px;
    margin-bottom: 2px;
  }
  
  .mobile {
    display: none;
  }
  
  .footer-container {
    flex-shrink: 0;
    height: 212px;
    margin-top: auto;
    background: ${theme.colors.lightBlue};
    background-image: url('/sidenav-footer-envelope.png'), url('/sidenav-footer-envelope-2.png');
    background-repeat: no-repeat, no-repeat;
    background-position: top -100px left -150px, bottom 0 right -30px;
    background-size: 290px, 180px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
  
  .footer-title {
    font-family: Graphik;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: white;
    margin-bottom: 5px;
  }
  
  .footer-subtitle {
    font-family: Graphik;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: white;
    padding: 0 30px;
  }
  
  .footer-button {
    display: flex;
    border: none;
    width: 220px;
    height: 56px;
    background: ${theme.colors.navy};
    border-radius: 4px;
    font-family: Graphik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    color: white;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 20px;
    transition: background 0.1s ease-in;
  }
  
  .footer-button:hover {
    background: ${theme.colors.blueHover};
    transition: background 0.1s ease-in;
  }
  
  @media only screen and (max-width: ${breakpoints.sm}px) {
    nav {
      width: 100vw;
      left: -540px;
    }
    
    .footer-container {
      max-width: 100vw;
    }    
    
    .fixed {
      width: 100vw;
      padding-top: 0px;
    }
    
    .nav-content {
      padding-top: 157px;
    }
  
    .container-nav-button {
      height: 72px;
    }
    .overlay.show {
      visibility: hidden;
    }
    
    .mobile {
      display: block;
    }
    
    .mobile.weather {
      display: flex;
      flex-basis: 70px;
      height: 71px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  
    .top {
      height: 72px;
      padding: 0 12px 14px 0;
    }
  }  
  
  @media only screen and (min-width: ${breakpoints.md}px) {
    .footer-container {
      height: 232px;
      background-image: url('/sidenav-footer-envelope.png'), url('/sidenav-footer-envelope-2.png');
      background-repeat: no-repeat, no-repeat;
      background-position: top -80px left 50px, bottom 0 right 30px;
      background-size: 290px, 350px;
    }
  }  
  
  @media only screen and (min-width: ${breakpoints.lg}px) {
    .footer-container {
      height: 232px;
    }
  }
  
  @media (hover: hover) {
    .heading-wrapper:hover > *, .heading-wrapper:hover {
      color: ${theme.colors.lightBlue};
      transition: color 0.1s ease-in;
    }  
  }
`
